import { getPublicAssetUrl } from '@/app/utils/getPublicAssetUrl';
import { Typography } from 'antd';

import styles from '~/app/login/login.module.css';

const { Text } = Typography;

type LoginBrandingProps = {
  subtitle: string;
};

export function LoginBranding({ subtitle }: LoginBrandingProps) {
  const apiUrl = import.meta.env.VITE_API_URL?.replace(/\/$/, '') || '';
  const logoUrl = `${apiUrl}/api/v1/app-logo/logo`;

  return (
    <div className={styles.logoContainer}>
      <img
        src={logoUrl}
        alt="Evimo Logo"
        width={350}
        height={80}
        style={{ objectFit: 'contain' }}
        onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = getPublicAssetUrl('assets/evimo_logo.png');
        }}
      />

      <Text className={styles.logoDescription}>{subtitle}</Text>
    </div>
  );
}
